<template>
<GeneralContainer>
<div>
	<RequestSigninModal ref="signinModal" :next="next"></RequestSigninModal>
	<h1>Your Sign-In link has expired</h1>
	<button @click="generateClick">
		Generate New Link
	</button>
</div>
</GeneralContainer>
</template>


<script>
import RequestSigninModal from "@/components/base/RequestSigninModal";
import GeneralContainer from "@/components/base/GeneralContainer";

export default {

	name: "ExpiredLink",

	components: {
		RequestSigninModal,
		GeneralContainer
	},

	data(){
		return {
			next: ""
		}
	},

	mounted(){
		this.next = decodeURI(this.$route.query.next);
		console.log(this.next)
	},

	methods: {
		generateClick(){
			this.$refs.signinModal.open();
		}
	}

}

</script>